// src/routes/routes.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Login from "../pages/Login";
import Register from "../pages/Register";
import BusinessListing from "../pages/BusinessListing";
import SearchResult from "../pages/SearchResult";
import BusinessProfile from "../pages/BusinessProfile";
import BusinessWebsite from "../pages/BusinessWebsite";
import Admin from "../pages/Admin";
import Profile from "../components/Profile";
import UpgradeListing from "../components/UpgradeListing";
import CommentsReviews from "../components/CommentsReviews";
import UserProfile from "../components/UserProfile";
function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/add-listing" element={<BusinessListing />} />
            <Route path="/search" element={<SearchResult />} />
            <Route path="/portfolio/:slug" element={<BusinessProfile />} />
            <Route path="/business-website/:id" element={<BusinessWebsite />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/upgradelisting" element={<UpgradeListing />} />
            <Route path="/commentsreviews" element={<CommentsReviews />} />
            <Route path="/userprofile" element={<UserProfile />} />


        </Routes>
    );
}

export default AppRoutes;

